import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Incident Number:", -1)

import { computed, ref, watch, onMounted } from 'vue';
import { SelectEntryType, SelectItem, SelectorMode } from '@/types';
import WebEntrySelectorLayout from '@/components/BSelector/WebEntrySelectorLayout.vue';
import { useContactsStore } from '@/stores/contactsStore';
import { AxiosResponse } from 'axios';
import { addIdPropertyToTargetArrays, handleErrorInResponse } from '@/utils';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactsWebEntry',
  props: {
    showNotFoundError: { type: Boolean },
    initialOri: { default: '' },
    initialIncidentNumber: { default: '' },
    url: {}
  },
  setup(__props: any, { expose: __expose }) {


const props = __props;

var idInput = ref(props.initialIncidentNumber);

const currentMode = ref({} as SelectEntryType);
const availableModes = ref([] as SelectorMode[]);
const validationError = ref("");

availableModes.value.push({type:SelectEntryType.Edit, label:'Edit', isDefaultSelection: true});

const contactsStore = useContactsStore();
contactsStore.setSelectedOri(props.initialOri);

var agencies = ref([] as SelectItem[])

const isValid = (mode:SelectEntryType):Boolean => {
    return contactsStore.getSelectedOri != "" && idInput.value != "";    
}

const notFoundMessage=computed(() => {
    let ori = contactsStore.getOriName;
    return `Unable to find the incident: ${idInput.value} in ${ori ?? contactsStore.getSelectedOri}. Please try your search again or contact your administrator.`;
});

__expose({ isValid })

function handleOriChange(newOri) {
    contactsStore.getSelectedOri = newOri;        
}

function handleModeChange(mode:SelectEntryType){    
    currentMode.value = mode;
    idInput.value = '';
}

function handleSubmit(ori:any, mode:SelectEntryType) {    
    if (contactsStore.getSelectedOri !== "" && idInput.value !== "") {
        validationError.value = "";
        try{
            contactsStore.fetchContacts(idInput.value, contactsStore.getSelectedOri).then((response:AxiosResponse) => {

            if (response == undefined || response.data == null || response.data.incident_number == null) {
                validationError.value = notFoundMessage.value;
            }
            else {
                contactsStore.contactFullReport = response.data;
                addIdPropertyToTargetArrays(contactsStore.contactFullReport);
            
                window.location.href = `ContactsEditor.aspx?incident=${encodeURIComponent(idInput.value)}&ori=${encodeURIComponent(contactsStore.getSelectedOri)}`;
                }
            });

        } catch (error) {
            contactsStore.contactFullReport = undefined;
            handleErrorInResponse(error);        
        }                
    }    
}

onMounted(() => {
    

    if (props.showNotFoundError) {
        validationError.value = notFoundMessage.value;
        }
})

watch(
    () => contactsStore.getSelectedOri,
    (val) => {
        validationError.value = "";
    }
);

watch(
    () => contactsStore.oris,
    () => {
        agencies.value = contactsStore.getOrisForSelectList;
    }
);

watch(
    () => idInput.value,
    (val) => {
        validationError.value = "";
    }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WebEntrySelectorLayout, {
    title: "Contacts Editor",
    "show-nav": availableModes.value.length > 1,
    modes: availableModes.value,
    error: validationError.value,
    agencies: _unref(agencies),
    onOriChange: handleOriChange,
    onModeChange: handleModeChange,
    onSubmit: handleSubmit
  }, {
    "extra-fields-edit": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(idInput) ? (idInput).value = $event : idInput = $event)),
          required: true,
          "aria-required": "true"
        }, null, 512), [
          [_vModelText, _unref(idInput)]
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-nav", "modes", "error", "agencies"]))
}
}

})